import { ArrowLeft, Copy, Link2, Pencil, Printer, Star } from "lucide-react";
import { useState } from "react";
import type { Trip } from "../types";

interface HeaderProps {
  trip: Trip;
  canEdit: boolean;
  canDuplicate: boolean;
  favorite: boolean;
  canFavorite: boolean;
  onBack: () => void;
  onEdit: () => void;
  onDuplicate: () => Promise<void>;
  onPrint: () => void;
  onToggleFavorite: () => void;
}

const statusCopy = { DRAFT: "草稿预览", IN_REVIEW: "审阅中", PUBLISHED: "已发布", ARCHIVED: "已归档" } as const;
const visibilityCopy = { PRIVATE: "工作区可见", LINK: "持链接可见", PUBLIC: "公开路线" } as const;

export function RouteViewerHeader({ trip, canEdit, canDuplicate, favorite, canFavorite, onBack, onEdit, onDuplicate, onPrint, onToggleFavorite }: HeaderProps) {
  const [copied, setCopied] = useState(false);
  const shareable = trip.status === "PUBLISHED" && (trip.visibility === "PUBLIC" || trip.visibility === "LINK");
  const copyShareLink = async () => {
    await navigator.clipboard.writeText(`${window.location.origin}/share/${encodeURIComponent(trip.id)}`);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1600);
  };

  return <header className="viewer-topbar">
    <button className="viewer-back" onClick={onBack}><ArrowLeft size={18} /><span>路线库</span></button>
    <div className="viewer-title"><span>{statusCopy[trip.status]} · {visibilityCopy[trip.visibility]}</span><strong>{trip.name}</strong></div>
    <div className="viewer-actions">
      {canFavorite && <button className={favorite ? "is-favorite" : ""} onClick={onToggleFavorite} title={favorite ? "取消收藏" : "收藏路线"}><Star size={17} fill={favorite ? "currentColor" : "none"} /><span>{favorite ? "已收藏" : "收藏"}</span></button>}
      {shareable && <button onClick={() => void copyShareLink()}><Link2 size={17} /><span>{copied ? "已复制" : "分享"}</span></button>}
      <button onClick={onPrint}><Printer size={17} /><span>行程单</span></button>
      {canEdit && <button className="viewer-primary" onClick={onEdit}><Pencil size={17} /><span>返回编辑</span></button>}
      {!canEdit && canDuplicate && <button className="viewer-primary" onClick={() => void onDuplicate()}><Copy size={17} /><span>复制为草稿</span></button>}
    </div>
  </header>;
}
